import { DynamicRow } from "./dynamic-row.model";

export class DynamicTabPanel<T> {

    header?: string;
    rows?: Array<DynamicRow<T>>;

    constructor(source: Partial<DynamicTabPanel<T>>) {
        Object.assign(this, source);
    }

}